import { useFormContext } from 'react-hook-form';

import type { QuestionReviewTaskQuestionDetailsFormValues } from './schema';

const useQuestionReviewTaskQuestionDetailsFormContext =
  useFormContext<QuestionReviewTaskQuestionDetailsFormValues>;

export default useQuestionReviewTaskQuestionDetailsFormContext;
